import styled from 'styled-components'

export const TextInputSublabel = styled.div`
  color: ${({ theme }) => theme.color.text.subdued};
  font-size: 14px;
  display: flex;
  justify-content: center;
`
